<template>
  <div class="notifications">
    <b-nav-item-dropdown right no-caret style="list-style: none;">
      <template v-slot:button-content>
        <div class="d-flex flex-column align-items-center">
          <div class="child-dropdown-image-container">
            <img :src="require(`@/assets/icons/navbar/ChildView.svg`)" alt="" />
          </div>
          <span class="text-light">Go to Child View</span>
        </div>
      </template>

      <b-dropdown-item v-if="!filteredChilds" class="d-block text-center p-4">
        <span class="material-icons full-icon align-middle">
          face
        </span>
        <p class="text-muted text-wrap">
          No child have been added yet.
        </p>
        <b-button variant="warning" class="mt-2 w-100" size="sm" to="register-child">
          Create
        </b-button>
      </b-dropdown-item>

      <b-dropdown-item v-else>
        <b-list-group-item
          v-for="item in filteredChilds"
          :key="item.id"
          @click="goChildProfile(item.id)"
          class="d-flex justify-content-between"
        >
          <p class="mr-3 text-capitalize small">{{ item.name }} {{ item.last_name }}</p>
          <p class="small text-muted">
            {{ item.stars }}
            <b-img
              :src="require('@/assets/icons/icon-money-star.png')"
              class="icon-star-small h-auto"
            ></b-img>
          </p>
        </b-list-group-item>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('user', ['getUserId', 'userIsAParent']),
    ...mapGetters('parent', ['getChildrenData']),
    filteredChilds() {
      return this.getChildrenData.filter((child) => child.child_enabled);
    },
  },
  methods: {
    ...mapMutations('user', ['setUserType', 'setUserData']),
    goChildProfile(idChild) {
      const childData = this.getChildrenData.find((data) => data.id == idChild);
      childData['originalParentId'] = this.getUserId;
      if (this.$route.name == 'Home') {
        this.setUserType('child');
        this.setUserData(childData);
        location.reload();
      } else {
        this.$router
          .push({ name: 'Home' })
          .then(() => {
            this.setUserType('child');
            this.setUserData(childData);
            window.location.href = '/';
          })
          .catch((err) => {
            console.log('Error change user', err);
          });
      }
    },
  },
};
</script>
<style lang="scss">
.dropdown-toggle {
  &.nav-link {
    padding: 0;
  }
}

.nav-item > a:hover {
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) !important;
}
.child-dropdown-image-container {
  width: 40px;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.notifications .dropdown-item {
  padding: 0;
  max-height: 300px;
  overflow-y: auto;
}
.notifications .dropdown-menu {
  padding: 0 !important;
  min-width: 13rem;
}

.navbar,
.child_info {
  .dropdown-menu {
    padding: 0 !important;
  }
}

.notifications .count {
  font-size: 50% !important;
  width: 15px;
  right: 10px;
}
</style>
